import { Text } from 'blaze-ui/Text/Text'
import Styles from '../UploadVideo.module.scss'
import { Dropzone } from 'screens/Uploads/Dropzone/Dropzone'
import { Image } from 'blaze-ui/icons'
import { VideoHighDetail, VoiceHighDetail } from 'blaze-ui/icons/40'

interface Props {
  onDrop: (files: File[]) => void
}

export const VideoDropzone = ({ onDrop }: Props) => {
  return (
    <>
      <div className={Styles.heading}>
        <Text variant="largeList">Upload your Video</Text>
      </div>
      <Dropzone
        onDrop={onDrop}
        accept={'video/*'}
        styles={Styles.dropzone}
        supportText={'Blaze supports mov, iOS mov, Android mp4 files up to 1GB'}
        IconComponent={() => (
          <div className={Styles.icons}>
            <Image size={50} />
            <VideoHighDetail size={50} />
            <VoiceHighDetail size={50} />
          </div>
        )}
      />
    </>
  )
}
